import { useFetchPeopleForAutocomplete } from "@/queries/useFetchPeopleForAutocomplete.ts";
import { CircularProgress, Typography } from "@mui/material";
import { RhfAutocomplete } from "mui-rhf-integration";
import type React from "react";
import { useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";

type Option = {
    id: string | null;
    name: string | null;
};

const CaseReferredByIndividualAutocomplete = () => {
    const [searchString, setSearchString] = useState("");
    const form = useFormContext();
    const formValue = form.watch("idReferredBy");

    const {
        data: { data } = {},
        isError,
        isRefetching,
        isLoading,
    } = useFetchPeopleForAutocomplete({
        searchString: searchString,
        fieldIdValue: formValue ?? null,
    });

    const options: Option[] = useMemo(() => {
        if (data) {
            return data.map((person) => ({
                id: person.idUUID,
                name: person.fullName ?? "",
            }));
        }
        return [];
    }, [data]);

    const handleInputChange = async (_event: React.SyntheticEvent, newInputValue: string) => {
        if (newInputValue.length >= 2) {
            setSearchString(newInputValue);
        }
    };

    return (
        <>
            {(isLoading || isRefetching) && <CircularProgress />}
            {isError && <Typography variant={"h5"}>Error loading people</Typography>}
            <RhfAutocomplete
                control={form.control}
                name="idReferredBy"
                options={options}
                loading={isLoading || isRefetching}
                onInputChange={handleInputChange}
                textFieldProps={{
                    label: "Referred By",
                }}
                // display the name attribute as the dropdown value
                getOptionLabel={(option: Option | string) => {
                    if (typeof option === "string") {
                        return option;
                    }

                    return option.name || "";
                }}
                getOptionKey={(option: Option | string) => {
                    if (typeof option === "string") {
                        return option;
                    }

                    return option.id || "";
                }}
                optionToValue={(option: Option | string) => {
                    if (typeof option === "string") {
                        return option;
                    }

                    return option.id || "";
                }}
                valueToOption={(value) => {
                    return options.find((option) => option.id === value);
                }}
                sx={{
                    backgroundColor: "#fff",
                }}
            />
        </>
    );
};

export default CaseReferredByIndividualAutocomplete;
